"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _BillingAddress = _interopRequireDefault(require("./BillingAddress"));
var _Contract = _interopRequireDefault(require("./Contract"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Account model module.
 * @module model/Account
 * @version 3.0
 */
var Account = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Account</code>.
   * @alias module:model/Account
   */
  function Account() {
    _classCallCheck(this, Account);
    Account.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Account, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Account</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Account} obj Optional instance to populate.
     * @return {module:model/Account} The populated <code>Account</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Account();
        if (data.hasOwnProperty('accountType')) {
          obj['accountType'] = _ApiClient["default"].convertToType(data['accountType'], 'String');
        }
        if (data.hasOwnProperty('displayName')) {
          obj['displayName'] = _ApiClient["default"].convertToType(data['displayName'], 'String');
        }
        if (data.hasOwnProperty('contract')) {
          obj['contract'] = _Contract["default"].constructFromObject(data['contract']);
        }
        if (data.hasOwnProperty('securityLockEnabled')) {
          obj['securityLockEnabled'] = _ApiClient["default"].convertToType(data['securityLockEnabled'], 'Boolean');
        }
        if (data.hasOwnProperty('ownerOfPrimaryIdentifier')) {
          obj['ownerOfPrimaryIdentifier'] = _ApiClient["default"].convertToType(data['ownerOfPrimaryIdentifier'], 'Boolean');
        }
        if (data.hasOwnProperty('primaryIdentifier')) {
          obj['primaryIdentifier'] = _ApiClient["default"].convertToType(data['primaryIdentifier'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
        if (data.hasOwnProperty('billingAddress')) {
          obj['billingAddress'] = _BillingAddress["default"].constructFromObject(data['billingAddress']);
        }
        if (data.hasOwnProperty('accountId')) {
          obj['accountId'] = _ApiClient["default"].convertToType(data['accountId'], 'Number');
        }
        if (data.hasOwnProperty('accountLegacyId')) {
          obj['accountLegacyId'] = _ApiClient["default"].convertToType(data['accountLegacyId'], 'String');
        }
        if (data.hasOwnProperty('accountName')) {
          obj['accountName'] = _ApiClient["default"].convertToType(data['accountName'], 'String');
        }
        if (data.hasOwnProperty('status')) {
          obj['status'] = _ApiClient["default"].convertToType(data['status'], 'String');
        }
        if (data.hasOwnProperty('statusReason')) {
          obj['statusReason'] = _ApiClient["default"].convertToType(data['statusReason'], 'String');
        }
        if (data.hasOwnProperty('statusDateTime')) {
          obj['statusDateTime'] = _ApiClient["default"].convertToType(data['statusDateTime'], 'String');
        }
        if (data.hasOwnProperty('billCycleDay')) {
          obj['billCycleDay'] = _ApiClient["default"].convertToType(data['billCycleDay'], 'Number');
        }
        if (data.hasOwnProperty('nextBillDate')) {
          obj['nextBillDate'] = _ApiClient["default"].convertToType(data['nextBillDate'], 'Date');
        }
        if (data.hasOwnProperty('billingMode')) {
          obj['billingMode'] = _ApiClient["default"].convertToType(data['billingMode'], 'String');
        }
        if (data.hasOwnProperty('billingContact')) {
          obj['billingContact'] = _ApiClient["default"].convertToType(data['billingContact'], 'String');
        }
        if (data.hasOwnProperty('legalContact')) {
          obj['legalContact'] = _ApiClient["default"].convertToType(data['legalContact'], 'String');
        }
        if (data.hasOwnProperty('created')) {
          obj['created'] = _ApiClient["default"].convertToType(data['created'], 'Date');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Account</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Account</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['accountType'] && !(typeof data['accountType'] === 'string' || data['accountType'] instanceof String)) {
        throw new Error("Expected the field `accountType` to be a primitive type in the JSON string but got " + data['accountType']);
      }
      // ensure the json data is a string
      if (data['displayName'] && !(typeof data['displayName'] === 'string' || data['displayName'] instanceof String)) {
        throw new Error("Expected the field `displayName` to be a primitive type in the JSON string but got " + data['displayName']);
      }
      // validate the optional field `contract`
      if (data['contract']) {
        // data not null
        _Contract["default"].validateJSON(data['contract']);
      }
      // ensure the json data is a string
      if (data['primaryIdentifier'] && !(typeof data['primaryIdentifier'] === 'string' || data['primaryIdentifier'] instanceof String)) {
        throw new Error("Expected the field `primaryIdentifier` to be a primitive type in the JSON string but got " + data['primaryIdentifier']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      // validate the optional field `billingAddress`
      if (data['billingAddress']) {
        // data not null
        _BillingAddress["default"].validateJSON(data['billingAddress']);
      }
      // ensure the json data is a string
      if (data['accountLegacyId'] && !(typeof data['accountLegacyId'] === 'string' || data['accountLegacyId'] instanceof String)) {
        throw new Error("Expected the field `accountLegacyId` to be a primitive type in the JSON string but got " + data['accountLegacyId']);
      }
      // ensure the json data is a string
      if (data['accountName'] && !(typeof data['accountName'] === 'string' || data['accountName'] instanceof String)) {
        throw new Error("Expected the field `accountName` to be a primitive type in the JSON string but got " + data['accountName']);
      }
      // ensure the json data is a string
      if (data['status'] && !(typeof data['status'] === 'string' || data['status'] instanceof String)) {
        throw new Error("Expected the field `status` to be a primitive type in the JSON string but got " + data['status']);
      }
      // ensure the json data is a string
      if (data['statusReason'] && !(typeof data['statusReason'] === 'string' || data['statusReason'] instanceof String)) {
        throw new Error("Expected the field `statusReason` to be a primitive type in the JSON string but got " + data['statusReason']);
      }
      // ensure the json data is a string
      if (data['statusDateTime'] && !(typeof data['statusDateTime'] === 'string' || data['statusDateTime'] instanceof String)) {
        throw new Error("Expected the field `statusDateTime` to be a primitive type in the JSON string but got " + data['statusDateTime']);
      }
      // ensure the json data is a string
      if (data['billingMode'] && !(typeof data['billingMode'] === 'string' || data['billingMode'] instanceof String)) {
        throw new Error("Expected the field `billingMode` to be a primitive type in the JSON string but got " + data['billingMode']);
      }
      // ensure the json data is a string
      if (data['billingContact'] && !(typeof data['billingContact'] === 'string' || data['billingContact'] instanceof String)) {
        throw new Error("Expected the field `billingContact` to be a primitive type in the JSON string but got " + data['billingContact']);
      }
      // ensure the json data is a string
      if (data['legalContact'] && !(typeof data['legalContact'] === 'string' || data['legalContact'] instanceof String)) {
        throw new Error("Expected the field `legalContact` to be a primitive type in the JSON string but got " + data['legalContact']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {String} accountType
 */
Account.prototype['accountType'] = undefined;

/**
 * @member {String} displayName
 */
Account.prototype['displayName'] = undefined;

/**
 * @member {module:model/Contract} contract
 */
Account.prototype['contract'] = undefined;

/**
 * @member {Boolean} securityLockEnabled
 */
Account.prototype['securityLockEnabled'] = undefined;

/**
 * @member {Boolean} ownerOfPrimaryIdentifier
 */
Account.prototype['ownerOfPrimaryIdentifier'] = undefined;

/**
 * @member {String} primaryIdentifier
 */
Account.prototype['primaryIdentifier'] = undefined;

/**
 * @member {String} message
 */
Account.prototype['message'] = undefined;

/**
 * @member {module:model/BillingAddress} billingAddress
 */
Account.prototype['billingAddress'] = undefined;

/**
 * @member {Number} accountId
 */
Account.prototype['accountId'] = undefined;

/**
 * @member {String} accountLegacyId
 */
Account.prototype['accountLegacyId'] = undefined;

/**
 * @member {String} accountName
 */
Account.prototype['accountName'] = undefined;

/**
 * @member {String} status
 */
Account.prototype['status'] = undefined;

/**
 * @member {String} statusReason
 */
Account.prototype['statusReason'] = undefined;

/**
 * @member {String} statusDateTime
 */
Account.prototype['statusDateTime'] = undefined;

/**
 * @member {Number} billCycleDay
 */
Account.prototype['billCycleDay'] = undefined;

/**
 * @member {Date} nextBillDate
 */
Account.prototype['nextBillDate'] = undefined;

/**
 * @member {String} billingMode
 */
Account.prototype['billingMode'] = undefined;

/**
 * @member {String} billingContact
 */
Account.prototype['billingContact'] = undefined;

/**
 * @member {String} legalContact
 */
Account.prototype['legalContact'] = undefined;

/**
 * @member {Date} created
 */
Account.prototype['created'] = undefined;
var _default = exports["default"] = Account;